import React, { useState } from 'react';
import { Button, Space, message } from 'antd';
import { ThunderboltOutlined, GlobalOutlined, DollarOutlined } from '@ant-design/icons';
import axios from 'axios';

const UpdateServersButton = ({ onUpdate }) => {
  const [loadingLatency, setLoadingLatency] = useState(false);
  const [loadingDomains, setLoadingDomains] = useState(false);
  const [loadingContabo, setLoadingContabo] = useState(false);
  const [loadingHetzner, setLoadingHetzner] = useState(false);

  const API_URL = 'https://activity.smartandsafe.com.co/api';

  const getHeaders = () => {
    const token = localStorage.getItem('accessToken');
    return { 'X-Authorization': `Bearer ${token}` };
  };

  const handleUpdateLatency = async () => {
    setLoadingLatency(true);
    try {
      await axios.post(`${API_URL}/update-latency`, {}, { headers: getHeaders() });
      message.success('Latencia actualizada correctamente');
      if (onUpdate) onUpdate();
    } catch (error) {
      console.error('Latency error:', error);
      message.error('Error al actualizar latencia: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoadingLatency(false);
    }
  };

  const handleSyncHetzner = async () => {
    setLoadingHetzner(true);
    try {
      const res = await axios.post(
        `${API_URL}/hetzner/sync-payments`,
        new URLSearchParams({ force: '1' }).toString(),
        { headers: getHeaders() },
      );
      const msg = res.data?.message || 'Hetzner sincronizado';
      message.success(msg);
      if (onUpdate) onUpdate();
    } catch (error) {
      console.error('Hetzner sync error:', error);
      message.error('Error Hetzner: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoadingHetzner(false);
    }
  };

  const handleSyncContabo = async () => {
    setLoadingContabo(true);
    try {
      const res = await axios.post(
        `${API_URL}/contabo/sync-payments`,
        new URLSearchParams({ force: '1' }).toString(),
        { headers: getHeaders() },
      );
      const msg = res.data?.message || 'Fechas Contabo sincronizadas';
      message.success(msg);
      if (onUpdate) onUpdate();
    } catch (error) {
      console.error('Contabo sync error:', error);
      message.error('Error Contabo: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoadingContabo(false);
    }
  };

  const handleUpdateDomains = async () => {
    setLoadingDomains(true);
    try {
      await axios.post(`${API_URL}/update-domains-quick`, {}, { headers: getHeaders() });
      message.success('Dominios verificados correctamente');
      if (onUpdate) onUpdate();
    } catch (error) {
      console.error('Domains error:', error);
      message.error('Error al verificar dominios: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoadingDomains(false);
    }
  };

  return (
    <Space>
      <Button
        icon={<ThunderboltOutlined />}
        onClick={handleUpdateLatency}
        loading={loadingLatency}
      >
        Actualizar Latencia
      </Button>
      <Button
        icon={<GlobalOutlined />}
        onClick={handleUpdateDomains}
        loading={loadingDomains}
      >
        Verificar Dominios
      </Button>
      <Button
        icon={<DollarOutlined />}
        onClick={handleSyncContabo}
        loading={loadingContabo}
      >
        Sync Contabo (manual)
      </Button>
      <Button
        icon={<DollarOutlined />}
        onClick={handleSyncHetzner}
        loading={loadingHetzner}
      >
        Sync Hetzner (manual)
      </Button>
    </Space>
  );
};

export default UpdateServersButton;
